import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=67dd9e8c&scoped=true&"
import script from "./js/login.js?vue&type=script&lang=js&"
export * from "./js/login.js?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=67dd9e8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd9e8c",
  null
  
)

export default component.exports